import React, { useState, useEffect } from 'react';

const testimonials = [
  {
    name: 'Aritra Dasgupta',
    role: 'Software Engineer',
    company: 'TechCorp India',
    avatar: '👨‍💻',
    text: 'JOB_Fusion helped me land my dream job within 3 weeks of graduation. The AI matching feature is incredibly accurate!',
    type: 'Student',
  },
  {
    name: 'Priya Sharma',
    role: 'HR Manager',
    company: 'InnovateTech',
    avatar: '👩‍💼',
    text: 'We reduced our hiring time by 60% using JOB_Fusion. The candidate screening tools are exceptional.',
    type: 'Employer',
  },
  {
    name: 'Dr. Rajesh Kumar',
    role: 'Placement Officer',
    company: 'IIT Bangalore',
    avatar: '👨‍🏫',
    text: 'Our placement rate jumped to 98% after integrating JOB_Fusion into our campus recruitment process.',
    type: 'Institution',
  },
];

const TestimonialsSection = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials?.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const t = testimonials?.[current];

  return (
    <section className="py-20 bg-[var(--color-muted)]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl font-bold text-[var(--color-foreground)] mb-12" style={{ fontFamily: 'Crimson Text, serif' }}>
          What Our Users Say
        </h2>

        <div className="bg-white rounded-2xl p-10 shadow-warm-lg transition-all duration-500">
          <div className="text-5xl mb-4">{t?.avatar}</div>
          <p className="text-lg text-[var(--color-card-foreground)] italic mb-6 leading-relaxed">
            "{t?.text}"
          </p>
          <div className="font-semibold text-[var(--color-foreground)]">{t?.name}</div>
          <div className="text-sm text-[var(--color-muted-foreground)]">{t?.role} · {t?.company}</div>
          <span className="inline-block mt-3 px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-[var(--color-primary)]">
            {t?.type}
          </span>
        </div>

        <div className="flex justify-center gap-2 mt-6">
          {testimonials?.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrent(idx)}
              className={`h-2.5 rounded-full transition-all duration-300 ${
                idx === current ? 'bg-[var(--color-primary)] w-6' : 'bg-[var(--color-border)] w-2.5'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
